export const hashedActiveIds = (active_ids) => {
    //sort
    var sorted_ids = active_ids.sort();
    return sorted_ids.join(",");
};

